import { render, staticRenderFns } from "./AdminExchanges.vue?vue&type=template&id=248c2a17&scoped=true&"
import script from "./AdminExchanges.vue?vue&type=script&lang=js&"
export * from "./AdminExchanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248c2a17",
  null
  
)

export default component.exports